package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_12_08_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The Hexagon Battle Open is this afternoon, and the group decides to preliminarily pass on the event. They plan to meet with Lady Soren Aventary of the Peers at lunch time, so there is always a chance that plan could change.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Dirk decides to stay in the inn for now, but the others head to the Traveler’s Doorstep to pick up Falorn’s crossbow. On the way there, our heroes have another run-in with the Carnage Crew. Goram alerts some nearby guards who take the names and particulars of the Carnage Crew members and tell them to walk away in peace. The guards ask our heroes to visit their station tomorrow to make a more complete report about the Carnage Crew.")
    }
}
